// dataTypes.js

export const _DATATYPE_RESDATE = "ResDate";
export const _DATATYPE_RESDATE_NAME = "Booked on";
export const _DATATYPE_CHECKIN = "CheckIn";
export const _DATATYPE_CHECKIN_NAME = "Checked-in";
export const _DATATYPE_CHECKOUT = "CheckOut";
export const _DATATYPE_CHECKOUT_NAME = "Checked-out";
export const _DATATYPE_SEARCHES = "SearchDate";

export const _TARGET_TYPES = [
    { value: _DATATYPE_RESDATE, label: _DATATYPE_RESDATE_NAME },
    { value: _DATATYPE_CHECKIN, label: _DATATYPE_CHECKIN_NAME },
    { value: _DATATYPE_CHECKOUT, label: _DATATYPE_CHECKOUT_NAME },
];
